module.exports = __webpack_public_path__ + "static/img/logo.9d5e98c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.png
// module id = ZBJ4
// module chunks = 65